export const formatAdsDate = (value) => {
    if (!value) return null;
    const d = new Date(value);
    if (!Number.isFinite(d.getTime())) return null;
    return d.toLocaleDateString('en-SG');
};

export const hasAdsText = (value) => Boolean(String(value || '').trim());

/** Supports new { date, sources[] } and legacy { date, source, count } rows. */
export const normalizeClickByDate = (adsClicks = []) => {
    if (!Array.isArray(adsClicks)) return [];
    return adsClicks
        .map((day) => {
            if (Array.isArray(day?.sources)) {
                return {
                    ...day,
                    sources: day.sources.filter(
                        (row) => hasAdsText(row?.source) || (row?.count ?? 0) > 0
                    )
                };
            }
            if (day?.source != null || day?.count != null) {
                return {
                    _id: day._id,
                    date: day.date,
                    sources: [{
                        source: day.source || '',
                        count: day.count ?? 0
                    }]
                };
            }
            return { ...day, sources: [] };
        })
        .filter((day) => formatAdsDate(day.date) && day.sources.length > 0);
};

export const sumAdsClicks = (adsClicks = []) =>
    normalizeClickByDate(adsClicks).reduce(
        (total, day) => total + day.sources.reduce((s, row) => s + (row.count || 0), 0),
        0
    );

/** Totals per source name across all dates. */
export const sumClicksBySource = (adsClicks = []) => {
    const totals = new Map();
    normalizeClickByDate(adsClicks).forEach((day) => {
        day.sources.forEach((row) => {
            const source = String(row.source || '').trim();
            if (!source) return;
            totals.set(source, (totals.get(source) || 0) + (row.count || 0));
        });
    });
    return [...totals.entries()]
        .map(([source, count]) => ({ source, count }))
        .sort((a, b) => a.source.localeCompare(b.source));
};

export const getSourceNamesFromAd = (ad) => {
    const fromLinks = (ad?.adsSource || [])
        .map((row) => String(row.source || '').trim())
        .filter(Boolean);
    const fromClicks = normalizeClickByDate(ad?.adsClicks || []).flatMap((day) =>
        day.sources.map((row) => String(row.source || '').trim()).filter(Boolean)
    );
    return [...new Set([...fromLinks, ...fromClicks])];
};
